module.exports = "/assets/ab8abe5f00c31aa95ee872936e5ce821.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AZ.png
// module id = 2342
// module chunks = 0